import React, { memo, useEffect, useRef, useState } from "react";
import styles from "./AddFunds.module.scss";
import Modal from "../Modal/Modal";
import { LeftArrowIcon } from "../../../../assets/icons/svgicons";
import Button from "../../Button/Button";
import InputFormik from "../../Formik/Input/InputFormik";
import { Col, Form, Row } from "react-bootstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { FORMIK_REGEX, Messages } from "../../../../utils/constants";
import { useDispatch, useSelector } from "react-redux";

const AddFunds = ({ show, handleClose, handleAddFunds, walletType }) => {
  const dispatch = useDispatch();
  const rowRef = useRef();
  const userInfo = useSelector((state) => state?.persist?.userInfo);

  const stripeSchema = {
    amount: Yup.string()
      .required("Required")
      .matches(FORMIK_REGEX.NONZERODECIMAL, Messages?.NONZERODECIMALVALIDATION)
      .test("is-decimal", "Two decimal places allowed", (val) => {
        if (val !== undefined) {
          return FORMIK_REGEX.TWODECIMALNUMBER.test(val);
        }
        return true;
      })
      .max(10, "Amount must be at most 10 digits"),
  };

  const wireSchema = {
    invoiceId: Yup.string().required("Required").max(25),
  };

  let validationSchema;
  if (walletType === "STRIPE") {
    validationSchema = Yup.object({
      ...stripeSchema,
    });
  } else {
    validationSchema = Yup.object({
      ...stripeSchema,
      ...wireSchema,
    });
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      amount: "",
      invoiceId: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (values.amount < 1) {
        formik.setFieldError("amount", "Minimum deposit is $1");
        return;
      }
      let dataObj = {};
      if (walletType === "STRIPE") {
        dataObj = {
          user_id: userInfo?.id,
          user_uid: userInfo?.user_uid,
          amount: Math.round(Number(formik.values.amount) * 100),
          totalAmount: Math.round(Number(formik.values.amount) * 100),
          orderCreatedFrom: "STRIPE_VIRTUAL_WALLET",
        };
      } else {
        dataObj = {
          amount: Number(formik.values.amount),
          invoiceId: formik.values.invoiceId,
        };
      }

      handleAddFunds(dataObj);
    },
  });

  return (
    <Modal
      show={show}
      handleClose={() => {
        handleClose();
        formik.resetForm();
      }}
      title={
        <span
          onClick={() => {
            handleClose();
            formik.resetForm();
          }}
        >
          <LeftArrowIcon />
          Back
        </span>
      }
      hideCloseBtn
      className={styles.edit_profile}
    >
      <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
        <Row ref={rowRef}>
          {walletType === "WIRE" && (
            <Col md={12}>
              <InputFormik
                name="invoiceId"
                label="Transaction id "
                variant="dark"
                control="input"
                type="text"
                className={styles.input}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Please enter transaction id "
                formik={formik}
                maxLength={30}
              />
            </Col>
          )}
          <Col md={12}>
            <InputFormik
              name="amount"
              label="Amount"
              variant="dark"
              control="input"
              type="text"
              className={styles.input}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Please enter amount"
              formik={formik}
              maxLength={30}
            />
          </Col>
        </Row>
        <Button
          type="button"
          fluid
          className={styles.submit_btn}
          onClick={(e) => {
            formik.handleSubmit(e);
          }}
        >
          Add Funds
        </Button>
      </form>
    </Modal>
  );
};

export default memo(AddFunds);
